<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Payments"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <ItpBox
    direction="column"
    class="h-100 w-100 overflow-hidden"
    v-if="loaded"
  >
    <DIV
      class="h-100 w-100 overflow-hidden position-relative"
    >
      <VueSlickgrid
        name="payments"
        :headerTitle="'Payments'|pgettext('PaymentsView')"
        :items="getItems"
        checkbox-row-selection
        :headerShowColumnSelectorButton="b_6466705138206980_headerShowColumnSelectorButton"
        :headerShowReloadButton="b_6466705138206980_headerShowReloadButton"
        footer-totals
        export-to-csv
        :exportToCsvFilename="'payments'|pgettext('ExportFilename')"
        :columnDefaults="b_6466705138206980_columnDefaults"
        :globs="messages"
        :columns="b_6466705138206980_columns"
        class="page--grid"
        ref="grid"
        @selectedRowsChanged="evh_6466705138206980_selectedRowsChanged($event, {})"
        @command="evh_6466705138206980_command($event, {})"
      >
        <DIV
          class="flex-grow-1 d-flex"
          slot="toolbar"
        >
          <PaymentsFilters
            @submit="evh_2285343489561581_submit($event, {})"
          >
          </PaymentsFilters>
        </DIV>
      </VueSlickgrid>
    </DIV>
  </ItpBox>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "payments",
    path: "/payments",
    component: "Payments"
  }
)

@Component()
export default class Payments extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getItems(...args: any[]) {
    if (this.parameters) {
      return this.$fn.fetch('list_payment', { parameters: this.parameters })
    }

    const parameters = this.params;
    return parameters && parameters.account && parameters.date_from
      ? this.$fn.fetch('list_payment', { parameters })
      : []
  }

  getInvoiceBadgeClass(...args: any[]) {
    const data = args[0];

    if (_.isEmpty(data)) {
      return;
    }

    const payment_balance = data.payment_balance || 0;
    const invoice_gross_amount = data.invoice_gross_amount

    if (payment_balance == 0) {
      return 'bg-green-200';
    }

    if (payment_balance < 0) {
      return 'bg-yellow-200';
    }

    if (payment_balance < invoice_gross_amount) {
      return 'bg-blue-200';
    }
  }

  @Prop({
    type: Object,
  })
  parameters!: object;

  @Watch('parameters')
  onParameters(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parameters")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  messages!: any;
  selectedItems!: any;
  params!: any;
  totals!: any;
  paymentMethods!: any;

  async $$load_paymentMethods() {
    return this.$fn.fetch('list_payment_method')
      .then(data => _.reduce(data, (m, v, k) => _.set(m, v.id, this.$fn.pgettext('PaymentMethod', v.name))))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_6466705138206980_headerShowColumnSelectorButton!: any;
  b_6466705138206980_headerShowReloadButton!: any;
  b_6466705138206980_columnDefaults!: any;
  b_6466705138206980_columns!: any;

  async $$load_b_6466705138206980_columns() {
    return [{
      field: "payment_method",
      name: this.$fn.pgettext("PaymentBrowserView", "Method"),
      formatter: {
        name: "gettext",
        context: "PaymentMethod",
        conversion: ["Unsnake"
          ,
          "Sentence"
          ,
        ]
        ,
        filterInput: true,
      }
      ,
    }
      ,
    {
      field: "transaction_number",
      name: this.$fn.pgettext("PaymentBrowserView", "Number"),
      type: "command",
      formatter: [{
        name: "chain",
        formatters: [{
          name: "link",
          href: "#",
        }
          ,
        {
          name: "cellclass",
          value: (row) => ({
            'font-weight-bold': true,
            'bg-yellow-200': !row.locked
          }),
        }
          ,
        ]
        ,
      }
        ,
      ]
      ,
    }
      ,
    {
      field: "transaction_type",
      name: this.$fn.pgettext("PaymentBrowserView", "Type"),
      formatter: {
        name: "gettext",
        context: "TransactionType",
        conversion: "Unsnake",
        filterInput: true,
      }
      ,
    }
      ,
    {
      field: "transaction_date",
      name: this.$fn.pgettext("PaymentBrowserView", "Date"),
      type: "date",
    }
      ,
    {
      field: "transaction_title",
      name: this.$fn.pgettext("PaymentBrowserView", "Title"),
    }
      ,
    {
      field: "transaction_code",
      name: this.$fn.pgettext("PaymentBrowserView", "Transaction code"),
    }
      ,
    {
      field: "statement_number",
      name: this.$fn.pgettext("PaymentBrowserView", "Statement number"),
    }
      ,
    {
      field: "description",
      name: this.$fn.pgettext("PaymentBrowserView", "Description"),
    }
      ,
    {
      field: "notes",
      name: this.$fn.pgettext("PaymentBrowserView", "Message"),
    }
      ,
    {
      field: "opening_balance",
      name: this.$fn.pgettext("PaymentBrowserView", "Opening balance"),
      type: "number",
      formatter: "number",
      noFooterTotals: true,
    }
      ,
    {
      field: "amount_in",
      name: this.$fn.pgettext("PaymentBrowserView", "In"),
      type: "number",
      formatter: "number",
    }
      ,
    {
      field: "amount_out",
      name: this.$fn.pgettext("PaymentBrowserView", "Out"),
      type: "number",
      formatter: "number",
    }
      ,
    {
      field: "closing_balance",
      name: this.$fn.pgettext("PaymentBrowserView", "Closing balance"),
      type: "number",
      formatter: "number",
      noFooterTotals: true,
    }
      ,
    {
      field: "currency",
      name: this.$fn.pgettext("PaymentBrowserView", "Currency"),
    }
      ,
    {
      field: "exchange_rate",
      name: this.$fn.pgettext("PaymentBrowserView", "Exchange Rate"),
      type: "number",
      formatter: "number",
      noFooterTotals: true,
    }
      ,
    {
      field: "reference_number",
      name: this.$fn.pgettext("PaymentBrowserView", "Ref Nr."),
    }
      ,
    {
      field: "file_number",
      name: this.$fn.pgettext("PaymentBrowserView", "File Nr."),
    }
      ,
    {
      field: "client_name",
      name: this.$fn.pgettext("PaymentBrowserView", "Client"),
      formatter: {
        name: "routeLink",
        to: "company",
        navigateOnIconClick: true,
        params: {
          id: "client_id",
        }
        ,
      }
      ,
    }
      ,
    {
      field: "invoice_sum_diff",
      name: this.$fn.pgettext("PaymentBrowserView", "Settlement Diff."),
      type: "number",
      formatter: "number",
      noFooterTotals: true,
    }
      ,
    {
      field: "invoices",
      name: this.$fn.pgettext("PaymentBrowserView", "Invoices"),
      formatter: [{
        name: "chain",
        mode: "mapReduce",
        separator: ", ",
        formatterContext: "value",
        formatters: [{
          name: "getvalue",
          opts: {
            field: "invoice_number",
            source: "value",
          }
          ,
        }
          ,
        {
          name: "routeLink",
          to: "invoice",
          navigateOnIconClick: true,
          params: {
            id: "id",
          }
          ,
        }
          ,
        {
          name: "badge",
          badgeClass: this.getInvoiceBadgeClass,
        }
          ,
        ]
        ,
      }
        ,
      ]
      ,
    }
      ,
    ]
  }

  dataMembers = ['messages', 'selectedItems', 'params', 'totals', 'paymentMethods', 'ux', 'b_7315092382398562_modalBindings', 'b_6466705138206980_headerShowColumnSelectorButton', 'b_6466705138206980_headerShowReloadButton', 'b_6466705138206980_columnDefaults', 'b_6466705138206980_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: null,
        selectedItems: [
        ]
        ,
        params: {
        }
        ,
        totals: [{
          id: 0,
          amount_in: 0,
          amount_out: 0,
        }
          ,
        ]
        ,
        paymentMethods: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_6466705138206980_headerShowColumnSelectorButton: false,
        b_6466705138206980_headerShowReloadButton: false,
        b_6466705138206980_columnDefaults: {
          sortable: false,
          filterable: true,
          resizable: true,
        }
        ,
        b_6466705138206980_columns: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("PaymentsView", "Payments"),
        icon: this.$config.payment.paymentsList.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4768_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4768, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_setData_4770_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_6466705138206980_setData_4770, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_6466705138206980_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_showModal_4772_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6466705138206980_showModal_4772, alias=undefined
    return {
      name: "Payment",
      props: {
        modal: true,
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_6466705138206980_command_4771_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_6466705138206980_command_4771, alias=undefined
    return $event.data.column.id === 'transaction_number'
  }

  async evh_6466705138206980_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_command.executeFromDOM(this, event, scope);
  }

  async act_2285343489561581_setData_4774_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2285343489561581_setData_4774, alias=undefined
    return {
      path: "params",
      value: $event.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_2285343489561581_script_4776_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2285343489561581_script_4776, alias=undefined
    this.$refs.grid.reload()
  }

  async act_2285343489561581_script_4776_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2285343489561581_script_4776, alias=undefined
    return {
      value: () => this.act_2285343489561581_script_4776_getActionArgs_value($event),
    }
  }

  async evh_2285343489561581_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2285343489561581_submit.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4768: actions.CloseModalAction;
    evh_7315092382398562_close_4767: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_6466705138206980_setData_4770: actions.SetDataAction;
    evh_6466705138206980_selectedRowsChanged_4769: actions.EventHandlerImpl;
    evh_6466705138206980_selectedRowsChanged: actions.EventHandlerGroup;
    act_6466705138206980_showModal_4772: actions.ShowModalAction;
    evh_6466705138206980_command_4771: actions.EventHandlerImpl;
    evh_6466705138206980_command: actions.EventHandlerGroup;
    act_2285343489561581_setData_4774: actions.SetDataAction;
    evh_2285343489561581_submit_4773: actions.EventHandlerImpl;
    act_2285343489561581_script_4776: actions.ScriptAction;
    evh_2285343489561581_submit_4775: actions.EventHandlerImpl;
    evh_2285343489561581_submit: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4768 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4768_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4767 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4768,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4767],
      }
    );
    const act_6466705138206980_setData_4770 = new actions.SetDataAction(
      {
        actionArgs: this.act_6466705138206980_setData_4770_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_selectedRowsChanged_4769 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_setData_4770,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_6466705138206980_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_selectedRowsChanged_4769],
      }
    );
    const act_6466705138206980_showModal_4772 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6466705138206980_showModal_4772_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_command_4771 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_showModal_4772,
        event: "command",
        when: this.evh_6466705138206980_command_4771_getWhen,
        displayName: "showModal",
      }
    );
    const evh_6466705138206980_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_command_4771],
      }
    );
    const act_2285343489561581_setData_4774 = new actions.SetDataAction(
      {
        actionArgs: this.act_2285343489561581_setData_4774_getActionArgs,
        events: [],
      }
    );
    const evh_2285343489561581_submit_4773 = new actions.EventHandlerImpl(
      {
        action: act_2285343489561581_setData_4774,
        event: "submit",
        displayName: "setData",
      }
    );
    const act_2285343489561581_script_4776 = new actions.ScriptAction(
      {
        actionArgs: this.act_2285343489561581_script_4776_getActionArgs,
        events: [],
      }
    );
    const evh_2285343489561581_submit_4775 = new actions.EventHandlerImpl(
      {
        action: act_2285343489561581_script_4776,
        event: "submit",
        displayName: "script",
      }
    );
    const evh_2285343489561581_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_2285343489561581_submit_4773, evh_2285343489561581_submit_4775],
      }
    );
    return {
      act_7315092382398562_closeModal_4768,
      evh_7315092382398562_close_4767,
      evh_7315092382398562_close,
      act_6466705138206980_setData_4770,
      evh_6466705138206980_selectedRowsChanged_4769,
      evh_6466705138206980_selectedRowsChanged,
      act_6466705138206980_showModal_4772,
      evh_6466705138206980_command_4771,
      evh_6466705138206980_command,
      act_2285343489561581_setData_4774,
      evh_2285343489561581_submit_4773,
      act_2285343489561581_script_4776,
      evh_2285343489561581_submit_4775,
      evh_2285343489561581_submit,
    }
  }
}

Vue.component("Payments", Payments);

</script>